$(document).ready(function(){
   AOS.init();

  window.addEventListener('load', AOS.refresh);

  // Listen for clicks on the quantity buttons (increment or decrement)
  $('body').on('click', '.quantity__button', function() {
    // Wait for 1 second to ensure the cart is updated
    setTimeout(function() {
      // Fetch the updated cart data
      $.getJSON('/cart.js', function(cart) {
        var totalPrice = cart.total_price / 100; // Convert from cents to dollars
        // Format the total price with commas
        var formattedPrice = totalPrice.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        // Output the formatted total price to the .totals__total-value class
        $('.totals__total-value').text('₱ ' + formattedPrice + ' PHP'); // Update the price on the page
      });
    }, 1000); // Set the delay to 1 second
  });



  
  $('.image-slider__container').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  });

  $('.image-slider__right').on('click', function(){
    $(".image-slider__container").slick('slickNext');
  });
  $('.image-slider__left').on('click', function(){
    $(".image-slider__container").slick('slickPrev');
  });


  //Count JS

  function numberCounter(){
        $('.counter').each(function() {
            var $this = $(this),
                countTo = $this.attr('data-count');
            
            $({ countNum: $this.text()}).animate({
            countNum: countTo
            },
        
            {
        
            duration: 1000,
            easing:'linear',
            step: function() {
                $this.text(Math.floor(this.countNum));
            },
            complete: function() {
                return $this.text(this.countNum);
                //alert('finished');
            }
        
            });  
    
        });
    }

  var numbers = $('.counter');
  
  $(window).scroll(function(){
      if( numbers.visible() == true ){
          numberCounter();
      } else if ( numbers.visible() == false ) {
          return ;
      }
  });


  // Dropdown Menu
  // $('.nav-link-parent').on('mouseenter', function(){
  //   $('.main-nav .dropdown-child').slideToggle();
  // });

  // $('.nav-link-parent').on('mouseleave', function(){
  //   $('.main-nav .dropdown-child').slideToggle();
  // });

  $('.nav-link-parent').on('mouseenter', function() {
    $(this).find('.dropdown-child').stop(true, true).slideDown();
  });

  $('.nav-link-parent').on('mouseleave', function() {
    $(this).find('.dropdown-child').stop(true, true).slideUp();
  });


  $(".hero-banner__arrow").click(function() {
    $('html, body').animate({
        scrollTop: $("#image_slider").offset().top
    }, 1000);
  });

  //INSTALLATIONS

  $('.js-installation-btn').on('click', function(e){
    e.preventDefault();
    
    let btnVideo = $(this).data('video');
    let btnImg = $(this).data('image');
    let btnTitle = $(this).data('title');
    let btnDesc = $(this).data('desc');
    let btnEnabled = $(this).data('enabled');

    $(".installation-modal .modal-image").attr("src", btnImg);
    $(".installation-modal .modal-video").find('iframe').attr("src", btnVideo);
    $(".installation-modal .modal-title").text(btnTitle);
    $(".installation-modal .modal-desc").html(btnDesc);

    if (btnEnabled == true){
      $(".installation-modal .modal-image").addClass('d-none');
      $(".installation-modal .modal-video").removeClass('d-none');
    } else {
      $(".installation-modal .modal-image").removeClass('d-none');
      $(".installation-modal .modal-video").addClass('d-none');
    }

    $('.installation-modal').addClass('modal-flex').fadeIn();

    // console.log(btnImg);
    // console.log(btnTitle);
    // console.log(btnDesc);
    // console.log(btnVideo);
  });

  $('.modal-close').on('click', function(){
    $('.installation-modal').fadeOut();
  });

  $('.about-close').on('click', function(){
    $('.about-us__modal').removeClass('about-flex').slideUp();
  });

  $('.about-us .cta-white').on('click', function(e){
    e.preventDefault();
    $('.about-us__modal').addClass('about-flex').slideDown();
  });

  $('.nav__menu-mobile').on('click', function(e){
    $('.nav-mobile-dropdown').slideToggle();
    $('.burger-line1').toggleClass('open-burger-1');
    $('.burger-line2').toggleClass('open-burger-2');
    $('.burger-line3').toggleClass('open-burger-3');
  });

  //AJAX ADD TO CART
  // $('#add-to-cart-form').on('submit', function(event) {
  //   event.preventDefault(); // prevent default form submission
  //   $.ajax({
  //     type: 'POST',
  //     url: '/cart/add.js',
  //     data: $(this).serialize(),
  //     dataType: 'json',
  //     success: function() {
  //       // Do something on success (e.g. show a success message)
  //     },
  //     error: function() {
  //       // Do something on error (e.g. show an error message)
  //     }
  //   });
  // });

  $('.footer-icon-card').on('click', function(e){
    e.preventDefault();
    
    let PopupGroup = $('.footer-popup-group');
    let PopupContent = $('.footer-popup');
    let cardIndex = $(this).data('index') - 1;

    PopupGroup.fadeIn();
    PopupContent.fadeOut().removeClass('d-flex');
    PopupContent.eq(cardIndex).addClass('d-flex');
    
  });

  $('.footer-popup-close').on('click', function(){
    let PopupGroup = $('.footer-popup-group');
    let PopupContent = $('.footer-popup');
    
    PopupGroup.fadeOut();
    PopupContent.removeClass('d-flex').fadeOut();
    
  });

  $('.redirect-fb-1').on('click', function(){
    window.location.href = "https://m.me/Aguahome";
  });

  
  // var urlParams = new URLSearchParams(window.location.search); //get all parameters
  // var param = urlParams.get('rental'); //extract the foo parameter - this will return NULL if foo isn't a parameter

  // if(param == 'on') { //check if foo parameter is 'bar'
  //     //$("#add-to-cart-form-new").attr("action", "https://shop.aguahome.ph/product-category/rental/");
  //     $('#add-to-cart-form-new').attr('action', 'https://shop.aguahome.ph/product-category/rental/');
  //     //$('#add-to-cart-form-new input').css('display', 'none');
  //     $('#add-to-cart-form-new input').val('RENT NOW')
  // } else if (param === 'leasing') {
  //     $('#add-to-cart-form-new input').val('Lease now');
  // } else {
  //     console.log('param not found');
  // }

    var urlParams = new URLSearchParams(window.location.search);

    // Extract both parameters individually
    var rentalParam = urlParams.get('rental');
    var leasingParam = urlParams.get('leasing');

    if (rentalParam === 'on') { 
        $('#add-to-cart-form-new').attr('action', 'https://shop.aguahome.ph/product-category/rental/');
        $('#add-to-cart-form-new input').val('RENT NOW');
    } else if (leasingParam === 'on') {
        $('#add-to-cart-form-new').attr('action', 'https://shop.aguahome.ph/product-category/leasing/');
        $('#add-to-cart-form-new input').val('LEASE NOW');
        $('.rental_price').css('display', 'none');
    } else {
        console.log('param not found');
    }

  $('.popup-image__close').on('click', function(){
    let popupVideo = $('.popup-youtube')[0];

    $('.popup-youtube').attr('src', '');
    
    //Pause for hosted videos
    //popupVideo.pause();
    
    $('.popup-image').fadeOut();

    setTimeout(function() {
        $('.popup-second').fadeIn();
        // your code here
    }, 400);

  });

  $('.popup-second-image__close').on('click', function(){
    $('.popup-second').fadeOut();
  });
  
  
});












